import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { getSegmentEventForSortField } from '../../../../helpers/getSegmentEventForSortField';
import { ISorting } from '../../../../../../../../store/model/list/types';
import { listSetSorting } from '../../../../../../../../rest/effects/list/listSetSorting';

/* dispatch to redux store and to backbone model, delete with backbone */

export const setSorting: ActionCreator<ThunkAction> = (
    listId: number,
    sorting: ISorting
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        const segmentEvent = getSegmentEventForSortField(sorting.sortField);
        dispatch(segmentTrackAction(segmentEvent));
        return dispatch(listSetSorting(listId, sorting));
    };
    return action;
};
